import { render, staticRenderFns } from "./SwitchBreadCrumb.vue?vue&type=template&id=54df0ae8&scoped=true"
import script from "./SwitchBreadCrumb.vue?vue&type=script&lang=ts"
export * from "./SwitchBreadCrumb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54df0ae8",
  null
  
)

export default component.exports